import { useTheme, } from '@mui/material';
import React, { forwardRef, useMemo } from 'react';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import Button from '../Button/Button';
import HistoryIcon from '@mui/icons-material/History';
import { Filter16, Save16, FolderOpen16 } from '@weave-design/icons';
export var DataGridButtonType;
(function (DataGridButtonType) {
    DataGridButtonType[DataGridButtonType["REFRESH"] = 0] = "REFRESH";
    DataGridButtonType[DataGridButtonType["FILTER"] = 1] = "FILTER";
    DataGridButtonType[DataGridButtonType["SAVE"] = 2] = "SAVE";
    DataGridButtonType[DataGridButtonType["SAVED_FILTERS"] = 3] = "SAVED_FILTERS";
})(DataGridButtonType || (DataGridButtonType = {}));
export const DataGridButton = forwardRef(function DataGridButton({ type, disabled, iconProps, title, variant, iconDataCy, dataCy, color, onClick, ...otherProps }, ref) {
    const { t } = useGlobalization();
    const palette = useTheme().palette;
    const enabledColor = palette?.[color ?? 'primary']?.dark ?? palette?.primary?.dark;
    const disabledColor = enabledColor + '50';
    const buttonIcon = useMemo(() => {
        switch (type) {
            case DataGridButtonType.FILTER:
                return (React.createElement(Filter16, { "data-cy": iconDataCy, color: disabled ? disabledColor : enabledColor, ...iconProps }));
            case DataGridButtonType.SAVE:
                return (React.createElement(Save16, { "data-cy": iconDataCy, color: disabled ? disabledColor : enabledColor, ...iconProps }));
            case DataGridButtonType.SAVED_FILTERS:
                return (React.createElement(FolderOpen16, { "data-cy": iconDataCy, color: disabled ? disabledColor : enabledColor, ...iconProps }));
            case DataGridButtonType.REFRESH:
            default:
                // TODO: This is temporary until the Weave DataRefresh16 color property works
                // return (
                // 	<DataRefresh16
                // 		data-cy={iconDataCy}
                // 		color={disabled ? disabledColor : enabledColor}
                // 		{...iconProps}
                // 	/>
                // );
                // Needed to adjust the margin to make it the same dimensions as the weave 16 icons
                return (React.createElement(HistoryIcon, { "data-cy": iconDataCy, color: disabled ? disabledColor : enabledColor, style: { margin: '-2px' }, ...iconProps }));
        }
    }, [disabled, type, iconDataCy, iconProps, enabledColor, disabledColor]);
    const buttonTitle = useMemo(() => {
        if (title)
            return title;
        else {
            switch (type) {
                case DataGridButtonType.FILTER:
                    return t('Filter');
                case DataGridButtonType.SAVE:
                    return t('Save');
                case DataGridButtonType.SAVED_FILTERS:
                    return t('Saved Filters');
                case DataGridButtonType.REFRESH:
                default:
                    return t('Refresh');
            }
        }
    }, [type, title]);
    return (React.createElement(Button, { ref: ref, color: color ?? 'primary', variant: variant ?? 'text', onClick: onClick, "data-cy": dataCy, disabled: disabled, startIcon: buttonIcon, ...otherProps }, buttonTitle));
});
export default DataGridButton;
